export const GET_PAGE_BY_ID_M = (id, preview: boolean) => `
  query {
    page(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      slug
      ivTeaserImage
      teaserTitle
      teaserLinkText
      teaserText
      pageLanguage
      content {
        __typename
        ...on Landingpage {
          heading
          preamble
        }
        ...on Standardpage {
          heading
          preamble
        }
        ...on  Insurancepage{
          heading
          preamble
        }
        ...on InsuranceClaimPage{
          heading
          preamble
        }
        ...on  Eventpage{
          heading
          preamble
          startDate
          endDate
        }
        ...on  Newspage{
          heading
          preamble
        }
        ...on  Reportpage{
          heading
          preamble
        }
      }
    }
  }
`;
